/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sgrp_FrameworkInputs */

const en_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

const ar_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأطر`)
};

const bn_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফ্রেমওয়ার্ক`)
};

const de_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

const es_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

const fr_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

const pt_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

const zh_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

const tr_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

const ru_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

const pl_sgrp_framework = /** @type {(inputs: Sgrp_FrameworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRAMEWORK`)
};

/**
* | output |
* | --- |
* | "FRAMEWORK" |
*
* @param {Sgrp_FrameworkInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const sgrp_framework = /** @type {((inputs?: Sgrp_FrameworkInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sgrp_FrameworkInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_sgrp_framework(inputs)
	if (locale === "bn") return bn_sgrp_framework(inputs)
	if (locale === "de") return de_sgrp_framework(inputs)
	if (locale === "es") return es_sgrp_framework(inputs)
	if (locale === "fr") return fr_sgrp_framework(inputs)
	if (locale === "pt") return pt_sgrp_framework(inputs)
	if (locale === "zh") return zh_sgrp_framework(inputs)
	if (locale === "tr") return tr_sgrp_framework(inputs)
	if (locale === "ru") return ru_sgrp_framework(inputs)
	if (locale === "pl") return pl_sgrp_framework(inputs)
	return en_sgrp_framework(inputs)
});